export const environment = {
  name: 'production',
  production: true,
  bypassAuth: false,
  apiUrl: 'https://backend.statsfootball.ca/api',
  sentryDNS: 'https://0a8601b9c6bdc6c875b82d8031e94e8a@o4505896772501504.ingest.sentry.io/4506010660569088',
  firebase: {
    apiKey: "AIzaSyCkpNnMeABDu-SIQoaw3hYZRdFTrFsO140",
    authDomain: "sportsstatistiques.firebaseapp.com",
    projectId: "sportsstatistiques",
    storageBucket: "sportsstatistiques.appspot.com",
    messagingSenderId: "814059008678",
    appId: "1:814059008678:web:ad9fdd8f9b03b1322e7a67"
  }
};
